// extracted by mini-css-extract-plugin
export var card = "timer-module--card--UcVXa";
export var description = "timer-module--description--4jDmg";
export var img = "timer-module--img--QGntW";
export var innerWrapper = "timer-module--innerWrapper--81hZC";
export var textBlock = "timer-module--textBlock--P0tIN";
export var title = "timer-module--title--AFwCt";